import { useLang } from 'hooks/lang';

import { loaders } from 'entities';

import { ResponsiveOverlay, Skeleton } from 'components/Blocks';
import { Logs } from 'components/Logs';

import { useProjectProfile } from '../../context';
import { ProjectOptionOverlayProps } from '../createProjectOption';

export function ProjectLogsModal({ close, isOpen }: ProjectOptionOverlayProps) {
  const { project } = useProjectProfile();

  const { t } = useLang();

  const { data, error, loading } = loaders.projects.projectLogs.use({
    params: {
      id: project?.id,
    },

    defaultValue: [],

    blockLoad: !isOpen,
  });

  return (
    <ResponsiveOverlay
      isOpen={isOpen}
      close={close}
      title={t('project-logs')}
      width="min(90vw, 860px)"
      className="overflow-y-auto"
      allowEscape
    >
      {loading || error ? (
        <Skeleton height={32} quantity={8} />
      ) : (
        <Logs loading={loading} logs={data || []} />
      )}
    </ResponsiveOverlay>
  );
}
